import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useDocumentosSetoriaisState } from "../context/documentos-setoriais-context";
import { useDocumentosSetoriaisController } from "../context/documentos-setoriais-controller";
import { DocumentoSetorialForm } from "./documento-setorial-form";

export const DocumentoSetorialDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useDocumentosSetoriaisController();
    const { dataResponse, showAddEdit } = useDocumentosSetoriaisState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Documento Setorial ${dataResponse?.id}`;
        return "Adicionar Documento Setorial";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <DocumentoSetorialForm />
        </DefaultDrawer>
    );
};
